import { ChangeDetectorRef, Component, Input } from '@angular/core'

import { AvatarService } from './../avatar/avatar.service'
import { AvatarStyle } from './../avatar/avatar-data'
import { ContrastCheckerService } from './../core/contrast-checker/contrast-checker.service'
import { SportIconService } from './sport-icon.service'
import { isRoundSportBallIcon, ROUND_SPORT_ICON_CLASS } from './round-sport-ball-icons'
import { StyleLoaderService } from '../core/style-loader/style-loader.service'

@Component({
  standalone: false,
  selector: 'se-team-avatar',
  host: {'class': 'se-team-avatar'},
  templateUrl: './team-avatar.component.html'
})
export class SeTeamAvatarComponent {

  @Input('se-data-size') size: string
  @Input('se-data-border') border: boolean = false
  @Input('se-data-white') white: boolean = false
  @Input('se-data-sport') sport: string
  @Input('se-data-team-color') teamColor: string
  @Input('se-data-img-url') imgUrl: string

  public componentClass: string = 'se-avatar'
  public componentStyle: AvatarStyle
  public hasImage: boolean = false
  public icon: string
  public iconColor: string
  public ballIconClass: string = ''

  public static FALLBACK_ICON_COLOR: string = 'se-gray-600'

  constructor(private changeDetectorRef: ChangeDetectorRef,
              private contrastCheckerService: ContrastCheckerService,
              private styleLoaderService: StyleLoaderService,
              private avatarService: AvatarService,
              private sportIconService: SportIconService) {
    // noop
  }

  ngOnChanges(): void {
    this.init()
  }

  public async init(): Promise<void> {

    const data = await this.avatarService.getData(this.size, this.border, this.imgUrl, true)
    this.componentClass = data.componentClass
    this.componentStyle = data.componentStyle
    this.hasImage = data.hasImage

    if (!this.hasImage) {
      this.initIcon()
    }

    this.changeDetectorRef.detectChanges()

  }

  public initIcon(): void {
    this.icon = this.sportIconService.getIconKeyBySportName(this.sport)
    this.iconColor = this.getIconColor()
    this.ballIconClass = (isRoundSportBallIcon(this.sport)) ? ROUND_SPORT_ICON_CLASS : ''
  }

  public getIconColor(): string {

    const seWhite = this.styleLoaderService.getVariable('se-white').value.hex

    if (this.white) {
      return seWhite
    }

    const defaultColor = this.styleLoaderService.getVariable(SeTeamAvatarComponent.FALLBACK_ICON_COLOR).value.hex

    if (!this.teamColor) {
      return defaultColor
    }

    if (this.teamColor.indexOf('#') === -1) {
      this.teamColor = `#${this.teamColor}`
    }

    return (this.contrastCheckerService.passes(seWhite, this.teamColor)) ? this.teamColor : defaultColor

  }

}
